// extracted by mini-css-extract-plugin
export var accordionWrapper = "_qr-2";
export var countryRow = "_qr-1";
export var countryRowDisabled = "_qr-4";
export var countryRowStandalone = "_qr-3";
export var inAnotherZone = "_qr-7";
export var listContainer = "_qr-0";
export var provinceRow = "_qr-5";
export var provinceRowDisabled = "_qr-6";